import React from 'react';
import useSWR from 'swr';
import { Application} from '../../api/ApiEntreprise'
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// import { ClipLoader } from 'react-spinners';

const API_BASE_URL = import.meta.env.VITE_API;

interface Props {
  companyId: number;
}

const fetcher = (url: string) => axios.get(url, {
  withCredentials:true,
  // headers: {
  //   Authorization: `Bearer ${localStorage.getItem('access_token')}`,
  // },
}).then(res => res.data.data);

const ApplicationsList: React.FC<Props> = ({ companyId }) => {
  const navigate = useNavigate();

  const { data: applications, error } = useSWR<Application[]>(
    `${API_BASE_URL}/Company/${companyId}/applications`,
    fetcher
  );

  const handleApplicationClick = (app: Application) => {
    navigate(`/Application/${app.id}`, { state: { application: app } });
  };

  if (error) return <div>Application recovery error.</div>;
  if (!applications) 
    return  <div className="flex justify-center items-center h-full">
  {/* <ClipLoader color="#36d7b7" loading={true} size={100} />Chargement des applications... */}
  <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-blue-300 mx-auto mt-4"></div>
</div>
  ;

  return (
    <div className="bg-white shadow-lg rounded-lg overflow-hidden">
      <div className="px-4 py-5 sm:px-6">
        <h2 className="text-2xl font-bold text-red-400 shadow-md p-2 rounded">Subscribed applications</h2>
      </div>
      <div className="border-t border-gray-200">
        <ul className="divide-y divide-gray-200">
          {applications.length > 0 ? (
            applications.map((app) => (
              <li
                key={app.id}
                className="flex items-center justify-between p-4 hover:bg-gray-50 cursor-pointer transition duration-200"
                onClick={() => handleApplicationClick(app)}
              >
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div
                      className={`h-10 w-10 rounded-full flex items-center justify-center ${
                        app.isSyncronized ? 'bg-green-100' : 'bg-gray-100'
                      }`}
                    >
                      <span className="text-lg font-semibold text-gray-700">{app.displayName.charAt(0).toUpperCase()}</span>
                    </div>
                  </div>
                  <span className="ml-3 text-lg font-medium text-gray-800">{app.displayName}</span>
                </div>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(app.redirectUris, '_blank');
                  }}
                  className="text-blue-300 hover:text-black"
                >
                  <ArrowRight className="h-5 w-5" />
                </button>
              </li>
            ))
          ) : (
            <li className="px-4 py-4 sm:px-6 text-gray-500">No applications found.</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default ApplicationsList;